import { ConfigurationParameters } from '@/define/commandSet/mavlink';

const setup = [
  {
    name: 'Configuration',
    commands: [ConfigurationParameters],
  },
];

export default setup;
